import React from "react";
import "./ReportStyle/Global.css";
import "./ReportStyle/reports.css";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../redux/actions/actions";

import ReportMenu from "../../components/Reports-component/ReportMenu";
import Calldetailsreports from "../../components/Reports-component/Calldetailsreports";
import Agentskillsetreports from "../../components/Reports-component/Agentskillsetreports";
import Agentlogin from "../../components/Reports-component/AgentLogin";
import Outbounddetailedreport from "../../components/Reports-component/Outbounddetailedreport";
import Outboundsummaryreport from "../../components/Reports-component/Outboundsummaryreport";
import Servicereport from "../../components/Reports-component/Servicereport";
import Yearlyreport from "../../components/Reports-component/Yearlyreport";
import Skillsetsummary from "../../components/Reports-component/Skillsetsummary";
import Weeklyreport from "../../components/Reports-component/Weeklyreport";
import Monthlyreport from "../../components/Reports-component/Monthlyreport";
import Quaterlyreport from "../../components/Reports-component/Quaterlyreport";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};

const ReportMainMenu = (props) => {
  return (
    <>
      {(() => {
        switch (props.selectedMenu) {
          case "ReportMenu":
            return <ReportMenu />;
          case "Calldetailsreports":
            return <Calldetailsreports />;
          case "Agentskillsetreports":
            return <Agentskillsetreports />;
          case "Agentlogin":
            return <Agentlogin />;
          case "Outbounddetailedreport":
            return <Outbounddetailedreport />;
          case "Outboundsummaryreport":
            return <Outboundsummaryreport />;
          case "Servicereport":
            return <Servicereport />;
          case "Yearlyreport":
            return <Yearlyreport />;
          case "Skillsetsummary":
            return <Skillsetsummary />;
          case "Weeklyreport":
            return <Weeklyreport />;
          case "Monthlyreport":
            return <Monthlyreport />;
          case "Quaterlyreport":
            return <Quaterlyreport />;
          default:
            return <ReportMenu />;
        }
      })()}
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(ReportMainMenu);
